import { createContext, useContext, useReducer } from "react";

export const FileStore = createContext<IContextProps>(null);

interface IContextProps {
    state: IState;
    dispatch: ({ type }: Dispatch) => void;
}

type Dispatch = { type, payload }

interface IState {
    search: Search;
    roleList: any[];
}
class Search {
    keywords: string;
    RoleId: string;
    membeClassID: string;
};
const initialArgs = {
    dataList: [],
    roleList: [],
    search: new Search(),
}

function reducer(state: IState, { type, payload }: Dispatch) {
    switch (type) {
        case "LoadRole":
            return {
                ...state,
                roleList:payload
            }
        case "SetSearch":
            return {
                ...state,
                search: {
                    ...state.search,
                    ...payload
                }
            }
        default:
            return state;
    }
}

export function AuthStoreProvider(props) {
    const [state, dispatch] = useReducer(reducer, initialArgs);

    const v = { state, dispatch };
    return <FileStore.Provider value={v}>{props.children}</FileStore.Provider>
}